import React, { Component } from 'react';
import { Route, Switch } from 'react-router-dom';

import AcessoNegado from './pages/AcessoNegado';
import NotFound from './pages/NotFound';
import { Loading } from './components';

// Containers
const Default = React.lazy(() => import('./containers/Default'));
const Home = React.lazy(() => import('./pages/Home'));
const Validacao = React.lazy(() => import('./pages/Validacao'));
const Page3 = React.lazy(() => import('./pages/Page3'));

class App extends Component {
  render() {
    return (
      <React.Suspense fallback={Loading}>
        <Switch>
          <Route exact path="/404" name="Page 404" render={props => <NotFound {...props} />} />
          <Route exact path="/500" name="Page 500" render={props => <AcessoNegado {...props} />} />
          <Route exact path="/validacao/:codigoVerificador" name="Meu diploma | UNINTER" render={props => <Validacao {...props} />} />
          <Route exact path="/page3" name="Meu diploma | UNINTER" render={props => <Page3 {...props} />} />
          <Route exact path="/" name="Meu diploma | UNINTER" render={props => <Home {...props} />} />
          <Route path="/" component={Default} />
        </Switch>
      </React.Suspense>
    );
  };
}

export default App;
